<ng-container *ngIf="activeLang">
    <!-- Button -->
    <button mat-icon-button class="hover-icon" [matMenuTriggerFor]="languages">
        <mat-icon [svgIcon]="'heroicons_outline:globe-alt'" class="default-icon"></mat-icon>
        <mat-icon [svgIcon]="'heroicons_solid:globe-alt'" class="hovered-icon"></mat-icon>
    </button>
    

    <!-- Language menu -->
    <mat-menu [xPosition]="'before'" #languages="matMenu">
        <ng-container *ngFor="let lang of availableLangs; trackBy: trackByFn">
            <button mat-menu-item (click)="setActiveLang(lang)">
                <span class="flex items-center">
                    <span class="ml-3 capitalize" translate>{{ lang.label }}</span>
                </span>
            </button>
        </ng-container>
    </mat-menu>

    <!-- Flag image template -->
    <!-- <ng-template let-lang #flagImage>
        <span class="relative w-6 shadow rounded-full overflow-hidden">
            <span class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"></span>
            <img class="w-full" [src]="getLanguageFlag(lang.code)" [alt]="'Flag image for ' + lang.lalel">
        </span>
    </ng-template> -->
</ng-container>